<!-- <div class="container flex flex-col mx-auto bg-white">
    <aside
      class="group/sidebar flex flex-col shrink-0 lg:w-[300px] w-[250px] transition-all duration-300 ease-in-out m-0 fixed z-40 inset-y-0 left-0 bg-white border-r border-r-dashed border-r-neutral-200 sidenav fixed-start loopple-fixed-start"
      id="sidenav-main"
    >
      <div
        class="hidden border-b border-dashed lg:block dark:border-neutral-700/70 border-neutral-200"
      ></div>

      <div class="flex items-center justify-center">
        <img src="../assets/img/logo_preto.png" class="w-1/2" />
      </div>

      <div
        class="hidden border-b border-dashed lg:block dark:border-neutral-700/70 border-neutral-200"
      ></div>

      <div class="relative pl-3 my-1 overflow-y-scroll">
        <div class="flex flex-col w-full font-medium">
          <div class="block pt-5 pb-[.15rem]">
            <div class="px-4 py-[.65rem]">
              <span
                class="font-semibold text-[0.95rem] uppercase dark:text-neutral-500/80 text-secondary-dark"
                >Menu</span
              >
            </div>
          </div>

          <div>
            <span
              class="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]"
            >
              <a
                routerLink="./"
                [routerLinkActiveOptions]="{exact: true}"
                routerLinkActive="text-amber-700"
                class="flex items-center flex-grow text-[1.15rem] dark:text-neutral-400/75 text-stone-500 hover:text-dark"
                >Dashboard</a
              >
            </span>
          </div>

          <div>
            <span
              class="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]"
            >
              <a
                routerLink="./members"
                routerLinkActive="text-amber-700"
                class="flex items-center flex-grow text-[1.15rem] dark:text-neutral-400/75 text-stone-500 hover:text-dark"
                >Usuários</a
              >
            </span>
          </div>

          <div>
            <span
              class="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]"
            >
              <a
                routerLink="./product"
                routerLinkActive="text-amber-700"
                class="flex items-center flex-grow text-[1.15rem]   dark:text-neutral-400/75 text-stone-500 hover:text-dark"
                >Produtos</a
              >
            </span>
          </div>

        </div>
      </div>
    </aside>
  </div> -->

<div>
  <app-sidebar></app-sidebar>
  <div class="relative md:ml-64 bg-blueGray-100">
    <app-cms-header></app-cms-header>
    <app-header-stats></app-header-stats>

    <div class="px-4 md:px-10 mx-auto w-full -m-24">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
  </div>
</div>
